
export default {
    name: 'Loader',

    props: {
        shouldCover: {
            type: Boolean,
            default: true,
        },
        loaderWhite: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 0,
        },
    },
}
